import { render, staticRenderFns } from "./substance.vue?vue&type=template&id=7bf86a01&scoped=true&"
import script from "./substance.vue?vue&type=script&lang=js&"
export * from "./substance.vue?vue&type=script&lang=js&"
import style0 from "./substance.vue?vue&type=style&index=0&id=7bf86a01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf86a01",
  null
  
)

export default component.exports